export type Locale = 'fr' | 'en' | 'nl'

export const LOCALES: Locale[] = ['fr', 'en', 'nl']
export const DEFAULT_LOCALE: Locale = 'fr'

/** Préfixe d'URL par langue (FR = racine, donc vide). */
export const LOCALE_PREFIX: Record<Locale, string> = {
  fr: '',
  en: '/en',
  nl: '/nl',
}

export const LOCALE_META: Record<
  Locale,
  { ogLocale: string; htmlLang: string; label: string }
> = {
  fr: { ogLocale: 'fr_BE', htmlLang: 'fr', label: 'Français' },
  en: { ogLocale: 'en_GB', htmlLang: 'en', label: 'English' },
  nl: { ogLocale: 'nl_NL', htmlLang: 'nl', label: 'Nederlands' },
}

/** Langue déduite du premier segment du chemin. Défaut: fr. */
export function detectLocale(pathname: string): Locale {
  const seg = pathname.split('/')[1] // '' pour '/', sinon le 1er segment
  if (seg === 'en') return 'en'
  if (seg === 'nl') return 'nl'
  return 'fr'
}

/** Retire le préfixe de langue, retourne toujours un chemin commençant par '/'. */
export function stripLocale(pathname: string): string {
  const locale = detectLocale(pathname)
  if (locale === 'fr') return pathname || '/'
  const rest = pathname.slice(LOCALE_PREFIX[locale].length)
  return rest === '' ? '/' : rest
}

/** Accès par chemin pointé ('a.b.c') dans un objet de messages. */
export function lookup(
  obj: unknown,
  path: string,
): string | undefined {
  const parts = path.split('.')
  let cur: unknown = obj
  for (const p of parts) {
    if (cur && typeof cur === 'object' && p in (cur as Record<string, unknown>)) {
      cur = (cur as Record<string, unknown>)[p]
    } else {
      return undefined
    }
  }
  return typeof cur === 'string' ? cur : undefined
}

/** Remplace les jetons {key} d'une chaîne par params[key]. Jeton sans param → laissé littéral. */
export function interpolate(
  raw: string,
  params?: Record<string, string | number>,
): string {
  if (!params) return raw
  return raw.replace(/\{(\w+)\}/g, (_, k) => (k in params ? String(params[k]) : `{${k}}`))
}
